<div tabindex="0"
     #mainElement
     (keyup)="mainClick($event)"
     class="ui-select-container dropdown open">
  <div class="ui-select-match"
       [ngClass]="{'input-disabled': disabled}"
       [attr.data-hidden]="inputMode">
        <span tabindex="-1"
              class="btn btn-default btn-secondary text-ellipsis form-control ui-select-toggle text-left"
              [ngClass]="{'input-disabled': disabled}"
              (click)="matchClick($event)"
              style="outline: 0;">
        <span *ngIf="isMultiSelect; then multiselectPlaceholder else normalPlaceholder"></span>
        <ng-template #multiselectPlaceholder>
          <span class="ui-select-placeholder" [ngClass]="{'text-muted': !numberOfChecked}">
            {{getPlaceholder()}}
          </span>
        </ng-template>
        <ng-template #normalPlaceholder>
          <span *ngIf="active.length <= 0" class="ui-select-placeholder">
            {{placeholder}}
          </span>
          <span *ngIf="active.length > 0" class="ui-select-match-text"
                [ngClass]="{'ui-select-allow-clear': allowClear && active.length > 0}"
                [innerHTML]="sanitize(active[0].text | translate)">
          </span>
        </ng-template>
        <em class="dropdown-toggle text-right"></em>
        <em class="caret pull-right"></em>
        <button
          type="button"
          title="Remove Value"
          [attr.test-id]="'remove-value-btn'"
          *ngIf="allowClear && active.length > 0 && !disabled"
          class="btn btn-xs remove-option-btn pull-right"
          (click)="removeClick(active[0], $event)">
          <em class="fa fa-light fa-times p-t-sm">
             <span aria-hidden="true" class="sr-only">Remove Value</span>
           </em>
        </button>
      </span>
  </div>
  <input type="text" autocomplete="false" tabindex="-1"
         (keydown)="inputEvent($event)"
         (keyup)="inputEvent($event, true)"
         (focus)="this.focus.emit(true)"
         (blur)="this.blur.emit(true)"
         [disabled]="disabled"
         class="form-control ui-select-search"
         *ngIf="inputMode"
         [placeholder]="getPlaceholder()">
</div>
<div tabindex="0"
     #dropdown
     class="ui-select-container dropdown open pos-abt">
  <!-- options template -->
  <ul *ngIf="optionsOpened && options && options.length > 0"
      class="dropdown-menu no-padding" role="menu">
    <li *ngIf="buttons?.length">
      <ul class="buttons ui-select-choices">
        <li *ngFor="let field of buttons | sortByTranslations:
                        triggerSortByTranslationPipe  :['text'] : true : sortByTranslationsEnabled | async"
            role="menuitem">
          <div class="ui-select-choices-row"
               (click)="field.callback()"
               [class.active]="isActive(field)"
               (mouseenter)="selectActive(field)">
            <a href="javascript:void(0)">
              <div>{{field.text | translate}}</div>
            </a>
          </div>
        </li>
      </ul>
    </li>
    <div *ngIf="isMultiSelect" class="multi-select-buttons">
      <a href="javascript:void(0)" (click)="selectAllCheck()">Select all</a>
      <a href="javascript:void(0)" (click)="selectAllCheck(false)">Clear</a>
    </div>
    <li [ngClass]="{'multi-select': isMultiSelect}" *ngIf="!firstItemHasChildren">
      <ul class="ui-select-choices">
        <li *ngFor="let o of options | sortByTranslations :
                        triggerSortByTranslationPipe :['text'] : true : sortByTranslationsEnabled | async"
            role="menuitem">
          <div class="ui-select-choices-row multi-select-row checkbox" *ngIf="!o.isDisabled"
               [class.active]="isActive(o)"
               [attr.test-id]="o.text"
               (mouseenter)="selectActive(o)"
               (click)="isMultiSelect ? setCheck(o, !o.isChecked) : selectMatch(o, $event)">
            <input *ngIf="isMultiSelect"
                   [checked]="o.isChecked"
                   type="checkbox">
            <a href="javascript:void(0)">
              <div [innerHtml]="sanitize(o.text | translate | highlight:inputValue)"></div>
            </a>
          </div>
          <div class="ui-select-choices-row multi-select-row disabled" *ngIf="o.isDisabled"
               [attr.test-id]="o.text">
            <a href="javascript:void(0)" class="text-muted">
              <div [innerHtml]="sanitize(o.text | translate | highlight:inputValue)"></div>
            </a>
          </div>
        </li>
      </ul>
    </li>
    <li *ngIf="firstItemHasChildren">
      <ul class="ui-select-choices dropdown-menu" role="menu">
        <li *ngFor="let c of options | sortByTranslations:
                        triggerSortByTranslationPipe :['text'] : true : sortByTranslationsEnabled | async; let index=index"
            role="menuitem">
          <div class="divider dropdown-divider" *ngIf="index > 0"></div>
          <div class="dropdown-header">{{c.text}}</div>
          <div *ngFor="let o of c.children | sortByTranslations:
                        triggerSortByTranslationPipe  :['text'] : true : sortByTranslationsEnabled | async"
               class="ui-select-choices-row"
               [class.active]="isActive(o)"
               (mouseenter)="selectActive(o)"
               (click)="selectMatch(o, $event)"
               [ngClass]="{'active': isActive(o)}">
            <a href="javascript:void(0)">
              <div [innerHtml]="sanitize(o.text | highlight:inputValue)"></div>
            </a>
          </div>
        </li>
      </ul>
    </li>
  </ul>
</div>
